// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".splide__slide[data-v-30e5f70e]{background:#000;display:flex;justify-content:center;align-items:center}.splide__slide img[data-v-30e5f70e]{width:100%;height:100%;-o-object-fit:scale-down;object-fit:scale-down}.previewWrap[data-v-30e5f70e]{margin:0 auto;min-height:100vh;display:flex;justify-content:center;align-items:center;text-align:center;font-size:15px;position:relative;z-index:2}", ""]);
// Exports
module.exports = exports;
